import { AxiosError } from "axios";

export class LoginError extends Error {
  constructor(error: AxiosError) {
    super(error.message);
    this.message = 'error.login.userPass';
    this.name = "LoginError";
  }
}
